import { useState } from 'react';

function FormField({
  label,
  name,
  type = 'text',
  value,
  onChange,
  error,
  placeholder,
  required = false,
  icon,
  rightIcon,
  options = null,
  rows = null,
  children,
  disabled = false,
}) {
  const [showPassword, setShowPassword] = useState(false);
  const isSelect = type === 'select';
  const isTextarea = type === 'textarea';
  const isPassword = type === 'password';
  
  const baseProps = {
    id: name,
    name,
    value,
    onChange,
    placeholder,
    className: `form-input ${error ? 'input-error' : ''} ${isTextarea ? 'form-textarea' : ''} ${disabled ? 'form-input-disabled' : ''}`,
    disabled
  };

  return (
    <div className="form-group">
      <label htmlFor={name} className="form-label">
        {label} {required && <span className="required">*</span>}
      </label>
      <div className={`input-wrapper ${isPassword ? 'input-wrapper-password' : ''} ${rightIcon ? 'input-wrapper-has-right' : ''}`}>
        {icon && (
          <svg className="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            {icon}
          </svg>
        )}
        {isSelect ? (
          <select {...baseProps}>
            <option value="">{placeholder}</option>
            {options?.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        ) : isTextarea ? (
          <textarea {...baseProps} rows={rows} />
        ) : (
          <input {...baseProps} type={isPassword && showPassword ? 'text' : type} />
        )}
        {rightIcon && <span className="input-right-icon">{rightIcon}</span>}
        {isPassword && (
          <button type="button" className="password-toggle-btn" aria-label={showPassword ? 'Hide password' : 'Show password'} onClick={() => setShowPassword((p) => !p)} tabIndex={-1}>
            {showPassword ? (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
            ) : (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
            )}
          </button>
        )}
        {children}
      </div>
      {error && <span className="error-message">{error}</span>}
    </div>
  );
}

export default FormField;
